import { FetchRequestActions } from '../../../../utils/request-actions-helpers/createRequestActions';
import { ApiConfig } from '../../../../config'
import { Level } from "../../../../models"
import { createRequestActionTypes } from "../../../../utils/request-actions-helpers/createRequestActionTypes";
import { RequestThunkParameters, createRequestThunk } from "../../../../utils/request-actions-helpers/createRequestThunk";
import { processLevelsResponse } from './processLevelsResponse';

export const fetchLevelsActionTypes = createRequestActionTypes('LEVELS')

export type LevelsActions = FetchRequestActions<Level[]>

export const fetchAllLevels = (config: ApiConfig) => {

    const thunkParams: RequestThunkParameters<Level[]> = {
        method: 'GET',
        requestActionTypes: fetchLevelsActionTypes,
        processResultBeforeDispatch: processLevelsResponse,
        url: `${config.API_URL}/knowledgeLevels/getAll`,
    }
    return createRequestThunk(thunkParams)
}

